import { Form, Input, notification } from 'antd';
import { useHistory } from 'react-router-dom';
import AuthLayout from 'components/layout/auth-layout/auth-layout.component';
import { useForgotPasswordMutation } from '../services/authApi';
import keySvg from 'assets/images/auth/key.svg';
import { SigninFormItem } from '../components/signin-form-item/signin-form-item';
import { AuthButtonComponent } from '../components/auth-button/auth-button.component';
import { useForm } from 'antd/lib/form/Form';
import { notificationDefaultError } from 'utils/ui';

const ForgotPassword = () => {
  const history = useHistory();
  const [form] = useForm();

  const [forgotPassword, { isLoading }] = useForgotPasswordMutation();

  const onSubmit = async (formState: any) => {
    try {
      await forgotPassword(formState).unwrap();
      notification.success({
        message: 'Check your email',
        description: "We've sent an email to the address provided. Click the link in the email to reset your password.",
        placement: 'topRight',
        duration: 8,
      });
      setTimeout(() => {
        history.replace('/signin');
      }, 2000);
    } catch (err: any) {
      notificationDefaultError(err?.data?.errors[0]?.message);
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AuthLayout showGotoSignin>
      <div className="flex align-items-start mt-8" style={{ letterSpacing: '0.5px' }}>
        <div className="mr-4">
          <img src={keySvg} alt="key" />
        </div>

        <div className="flex-1">
          <p className="text-base font-semibold mb-2" style={{ color: '#050D43' }}>
            Forgot Password
          </p>
          <p style={{ color: '#6B7D8B' }}>We will send you an email to reset your password.</p>

          <Form
            form={form}
            name="basic"
            onFinish={onSubmit}
            onFinishFailed={onFinishFailed}
            size="large"
            layout="vertical"
            autoComplete="off"
            className="fadein animation-duration-500 w-full mt-6"
          >
            <SigninFormItem
              form={form}
              formName="email"
              label="Enter your email address"
              formRules={[
                { required: true, message: 'Please enter your email address' },
                { type: 'email', message: 'Please enter your full email address' },
              ]}
              hasEmailSuffix
            >
              <Input />
            </SigninFormItem>

            <Form.Item className="mt-6 text-right">
              <AuthButtonComponent isLoading={isLoading}>Submit</AuthButtonComponent>
            </Form.Item>
          </Form>
        </div>
      </div>
    </AuthLayout>
  );
};

export default ForgotPassword;
